import Vue from "vue";
import App from "./App.vue";
import router from "@/router.js";
import "@/assets/css/style.css";
import Element from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import VueAMap from "vue-amap";

import axios from "./utils/request.js";

import VueI18n from "vue-i18n";

import en from "./i18n/en.js";
import zh from "./i18n/zh.js";

Vue.use(VueI18n);

Vue.use(VueAMap);
Vue.use(Element, { size: "small" });

Vue.prototype.$http = axios;

Vue.config.productionTip = false;

const i18n = new VueI18n({
	locale: "zh",
	messages: {
		en,
		zh
	}
});

VueAMap.initAMapApiLoader({
	// 高德的key
	key: "bac931dd9653501c1a3b9b1e5e97d230",
	// 插件集合
	plugin: [
		"AMap.Autocomplete",
		"AMap.PlaceSearch",
		"AMap.Scale",
		"AMap.OverView",
		"AMap.ToolBar",
		"AMap.MapType",
		"AMap.PolyEditor",
		"AMap.CircleEditor"
	]
});

new Vue({
	i18n,
	router,
	render: h => h(App)
}).$mount("#app");



